import { Timeslot } from "../timeslots.types";

export function groupTimeslotsByTime(timeSlots: Timeslot[]) {
  const grouped = new Map<string, Timeslot[]>([]);

  for (const slot of timeSlots) {
    const key = slot.local.start.formattedTime;

    if (!grouped.has(key)) {
      grouped.set(key, []);
    }

    grouped.get(key)!.push(slot);
  }

  // Sort entries by time using the slot's hour/minute values (not the formatted string)
  const sortedEntries = [...grouped.entries()].sort((a, b) => {
    const slotA = a[1][0]; // First slot in group A
    const slotB = b[1][0]; // First slot in group B

    const hourA = slotA.local.start.hour;
    const minuteA = slotA.local.start.minute;
    const hourB = slotB.local.start.hour;
    const minuteB = slotB.local.start.minute;

    return hourA !== hourB ? hourA - hourB : minuteA - minuteB;
  });

  // Sort slots within each time group by date to ensure column alignment
  return sortedEntries.map(([time, slots]) => {
    const sortedSlots = [...slots].sort((a, b) => {
      // Sort by localDateISO (YYYY-MM-DD format) for consistent local date ordering
      return a.local.start.localDateISO.localeCompare(b.local.start.localDateISO);
    });
    return [time, sortedSlots] as [string, Timeslot[]];
  });
}

export default groupTimeslotsByTime;

